import React, { useContext, useEffect, useState } from 'react';
import { Container, Dialog, DialogTitle, DialogContent, TextField, Select, MenuItem, DialogActions, InputLabel , Typography, Box, Button, Card, CardContent, CardActions, Item, BottomNavigation, BottomNavigationAction } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import MenuAppBar from '../components/MenuAppBar';
import MenuBottAppBar from '../components/MenuBottAppBar';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import axios from "axios";


const EnergieEntita = () => {
  const { id } = useState(null);
  const navigate = useNavigate();
  const [energieentitas, setEnergieentitas] = useState([]);
  const [energieentitasrole, setEnergieentitasrole] = useState([]);
  const [energieentita, setEnergieentita] = useState({ idenergieentita: null, entita: '', hassioid: '', role: '' });
  const [selectedenergieentita, setSelectedenergieentita] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const axiosInstance = axios.create({
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`, // Using sessionStorage for token
    },
  });
  
  const getAuthHeaders = () => {
    const token = localStorage.getItem("accessToken");
    return { Authorization: `Bearer ${token}` };
  };

  const loadData = async () => {


    const energieentitas = await axios.get("/api/energie/entita", { headers: getAuthHeaders(), params:{}});
    setEnergieentitas(energieentitas.data);

    const energieentitarole = await axios.get("/api/energie/entitarole", { headers: getAuthHeaders(), params:{}});
    setEnergieentitasrole(energieentitarole.data);

    
    setLoading(false);
    

    
   


  };

  useEffect(() => {
    setLoading(true);
    loadData();
  }, []);

  
  const handleSaveEdit = async (e) => {
    if (selectedenergieentita) {
      /*axios.post("/api/energie/entita", { headers: getAuthHeaders(), params:{selectedenergieentita}}).then(() => {
        setEnergieentitas((prev) => prev.map((energieentita) => (energieentita.idenergieentita === selectedenergieentita.idenergieentita ? selectedenergieentita : energieentita)));
        setSelectedenergieentita(null);
      });*/
      const edenergieentita = await axios.post("/api/energie/entita", selectedenergieentita,{ headers: getAuthHeaders(), params:{}});
      setEnergieentitas((prev) => prev.map((energieentita) => (energieentita.idenergieentita === selectedenergieentita.idenergieentita ? selectedenergieentita : energieentita)));
      setSelectedenergieentita(null);
    }
  };

  const handleEdit = (energieentita) => {
    setSelectedenergieentita(energieentita);
  };
  const handleAdd = () => {
    setSelectedenergieentita({ idenergieentita: null, entita: '', hassioid: '', role: '' });
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div>
      <h1>{id ? 'Edit Entity' : 'Entities'}</h1>
      {!selectedenergieentita && (
        <div>
          <button onClick={() => handleAdd()}>Add New Entity</button>
          <ul>
            {energieentitas.map((ent, index) => (
              <li key={ent.idenergieentita}>
                {ent.entita}{' '}
                <button onClick={() => handleEdit(ent)}>Edit</button>
              </li>
            ))}
          </ul>
        </div>
      )}
      {selectedenergieentita && (
        <Dialog 
          open={true} 
          onClose={() => setSelectedenergieentita(null)}
          fullWidth="true"
          maxWidth="sm">
        <DialogTitle>Editace aplikace</DialogTitle>
        <DialogContent>
          <InputLabel>Entita</InputLabel>
          <TextField
            fullWidth
            variant="outlined"
            value={selectedenergieentita.entita}
            onChange={(e) => setSelectedenergieentita({ ...selectedenergieentita, entita: e.target.value })}
          />
          <InputLabel>Home Assistant id</InputLabel>
          <TextField
            fullWidth
            variant="outlined"
            value={selectedenergieentita.hassioid}
            onChange={(e) => setSelectedenergieentita({ ...selectedenergieentita, hassioid: e.target.value })}
          />
          <InputLabel>Role</InputLabel>
          <Select
            value={selectedenergieentita.role}
            label="Role"
            onChange={(e) => setSelectedenergieentita({ ...selectedenergieentita, role: e.target.value })}
          >
            
            {energieentitasrole.map((role, index) => (
              <MenuItem value={role} key={"role-"+index}>{role}</MenuItem>
            ))}
            
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSelectedenergieentita(null)}>Zrušit</Button>
          <Button variant="contained" onClick={handleSaveEdit}>Uložit</Button>
        </DialogActions>
      </Dialog>
      )}
    </div>
  );
};

export default EnergieEntita;